import { create } from "zustand";

const now = new Date();
const alertasFiltrosStore = create((set) => ({
    /*FILTROS DE REPORTE*/
    firstLoad: true,
    setFirstLoad: (data) => set({ firstLoad: data }),
    alertas: [],
    editarAlertas: (data) => set({ alertas: data }),
    vehiculos: [],
    editarVehiculos: (data) => set({ vehiculos: data }),
    geocercas: [],
    editarGeocercas: (data) => set({ geocercas: data }),
    filtros: null,
    editarFiltros: (data) => set({ filtros: data }),
    fechaInicio: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0),
    editarFechaInicio: (data) => set({ fechaInicio: data }),
    fechaFin: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59),
    editarFechaFin: (data) => set({ fechaFin: data }),
    fechaInicioBefore: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0),
    editarFechaInicioBefore: (data) => set({ fechaInicioBefore: data }),
    fechaFinBefore: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59),
    editarFechaFinBefore: (data) => set({ fechaFinBefore: data }),
    filtrosAfter: null,
    editarFiltrosAfter: (data) => set({ filtrosAfter: data }),
    filtrosBefore: null,
    editarFiltrosBefore: (data) => set({ filtrosBefore: data }),
    /*FILTROS DE REPORTE*/
}));

export default alertasFiltrosStore;